<template>
    <Can v-if="hasActivities" ability="view" :model>
        <Link data-test="activities" :href="model.url.activities" class="btn btn-secondary ms-2" v-bind="$attrs">
        <i class="fa fa-clipboard-list"></i>
        </Link>
    </Can>
</template>

<script lang="ts">
import type Model from '@/models/Model'
import { Component, Prop, Vue, toNative } from 'vue-facing-decorator'
import Can from '../Can.vue'
import Link from '../Link.vue'

@Component({
    components: {
        Can,
        Link,
    },
    inheritAttrs: false,
})
class ActivitiesButton extends Vue {
    @Prop({ type: Object, required: true })
    readonly model!: Model

    get hasActivities(): boolean {
        return !!this.model?.url?.activities
    }
}

export default toNative(ActivitiesButton)
</script>
